import {
  type EmailCategoryGroup,
  isEmailCategoryGroup,
} from '@/lib/email-category/groups'

/**
 * The gallery's `?type=` names a browse group (the chips) or a category
 * (links from before groups, the API's own vocabulary). Three groups share
 * a name with their only category (newsletter, content, internal), so
 * either reading lists the same templates.
 */
export function templateTypeFilter(type: string | undefined): {
  category?: string
  group?: EmailCategoryGroup
} {
  if (!type) {
    return {}
  }
  return isEmailCategoryGroup(type) ? { group: type } : { category: type }
}
